import { IconProps, IIconsetMap } from './Icon.types'
import * as CommerceIcons from './commerce'
import MaterialDesign from './material-design'

const defaultIcon = 'MdErrorOutline'
const defaultIconset = 'md'

const IconsetsMap: IIconsetMap = {
  md: MaterialDesign,
  cm: CommerceIcons
}

const Icon = ({
  className = '',
  name = defaultIcon,
  iconset = defaultIconset,
  size,
  color,
  title,
  ...props
}: IconProps) => {
  const IconItem = () => {
    const getIcon = IconsetsMap[iconset][name]

    return (getIcon || MaterialDesign[defaultIcon])({
      className: `Icon ${className}`,
      size,
      color,
      title,
      role: 'img'
    })
  }

  return <IconItem {...props} />
}

export default Icon
